import classNames from '@components/utils/classNames'
import Link from 'next/link'
import {
  CLEARANCE_TEXT_VARIABLE,
  IMG_PLACEHOLDER,
} from '@components/utils/textVariables'
import 'swiper/css'
import 'swiper/css/navigation'
import SwiperCore, { Navigation, FreeMode } from 'swiper'
import { useEffect, useMemo, useRef } from 'react'
import { matchStrings } from '@framework/utils/parse-util'
import { Swiper, SwiperSlide } from 'swiper/react'
import { generateUri } from '@commerce/utils/uri-util'
import { useUI } from '@components/ui/context'
import {
  checkIsLoadedOnMobile,
  removePrecedingSlash,
} from '@framework/utils/app-util'
import { useProductColorsPDP } from './hook/productColorsPDP.hook'
import { API_STATUS } from '@components/utils/constants'

let currentScrollY: number

export default function ProductColorsPDP({
  items = [],
  onChange = () => {},
  fieldCode = '',
  currentVariantData,
  forInputSelection = false,
  selectedValue = null,
  deviceInfo,
  setGetColorAPIStatus,
}: any) {
  const isLoadedOnMobile = checkIsLoadedOnMobile()
  const { isMobile, isIPadorTablet, isOnlyMobile } = deviceInfo
  const {
    slug,
    isActive,
    selectedGroupName,
    handleChange,
    onTabCick,
    getAllGroups,
    handleError,
  } = useProductColorsPDP({
    fieldCode,
    isMobile,
    isIPadorTablet,
    items,
    currentVariantData,
    isLoadedOnMobile,
    onChange,
  })
  const prevScrollY = useRef(0)
  const { setScrollY } = useUI()
  const _getAllGroups = useMemo(() => {
    return getAllGroups()
  }, [])

  SwiperCore.use([Navigation])
  const css = { maxWidth: '100%', height: 'auto' }

  useEffect(() => {
    setGetColorAPIStatus && setGetColorAPIStatus(API_STATUS.SUCCESS)
    const handleScroll = () => {
      currentScrollY = window?.scrollY
      prevScrollY.current = currentScrollY
    }
    window?.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window?.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      {/* {(isMobile || isIPadorTablet || isLoadedOnMobile) ? ( */}
      <div className="mobile-tab">
        <div
          className={`flex-1 px-0 sm:px-0 md:px-4 quick-view-padding-0 ${
            isOnlyMobile || isLoadedOnMobile ? 'pl-0 pr-0' : ''
          }`}
        >
          <ul
            className={`flex justify-start w-full -mb-px overflow-x-auto text-center border-b border-gray-200 mobile-h-scroll  ${
              isOnlyMobile || isLoadedOnMobile ? 'pl-4 pr-4' : ''
            }`}
            role="tablist"
          >
            {_getAllGroups?.map(([key, values]: any, iid: number) => {
              return (
                <div key={iid}>
                  {key != 'null' && (
                    <li
                      key={`product-${iid}-color-${key.replace(' ', '')}`}
                      className="flex justify-center text-center capitalize min-w-group"
                    >
                      <a
                        // className={
                        //   'py-2 min-w-group font-semibold text-sm rounded-t-lg capitalize text-brown-light' +
                        //   (iid == isActive
                        //     ? ' border-blue-600 border-b-2 border-black active dark:text-blue-500 dark:border-blue-500 text-primary'
                        //     : ' text-blue-600 border-b-2 border-white bg-white text-brown-light')
                        // }
                        className={`py-2 min-w-group font-semibold text-sm rounded-t-lg capitalize ${
                          iid == isActive
                            ? `border-blue-600 border-b-2 border-black active ${
                                key.toLowerCase() === CLEARANCE_TEXT_VARIABLE
                                  ? 'text-orange'
                                  : 'dark:text-blue-500 text-primary'
                              } dark:border-blue-500`
                            : `border-b-2 border-white bg-white ${
                                key.toLowerCase() === CLEARANCE_TEXT_VARIABLE
                                  ? 'text-orange opacity_056'
                                  : 'text-blue-600 text-brown-light'
                              }`
                        }`}
                        onClick={() => onTabCick(iid)}
                        data-toggle="tab"
                        role="tablist"
                      >
                        {key.toLowerCase()}
                        <sup
                          className={`ml-1 opacity_056`}
                        >{`${values?.length}`}</sup>
                      </a>
                    </li>
                  )}
                </div>
              )
            })}
          </ul>
          <div className={`flex-1 mt-3 `}>
            {_getAllGroups?.map(([key, values]: any, iid: number) => {
              return (
                <div
                  className={`px-0 ${
                    !isOnlyMobile && !isLoadedOnMobile
                      ? 'pb-4 mb-4 border-b border-gray-200 border-dashed'
                      : 'pb-2'
                  } sm:px-0 ${iid == isActive ? 'block' : 'hidden'} `}
                  key={`product-${iid}-iid-color`}
                >
                  <span
                    className={`sr-only ${
                      isOnlyMobile || isLoadedOnMobile ? 'pl-4 pr-4' : ''
                    }`}
                  >
                    {key}
                  </span>
                  <div className="grid content-center grid-cols-1 icon-hide-mob">
                    <div
                      className={`flex content-center col-span-1 ${
                        isOnlyMobile || isLoadedOnMobile ? 'pl-4 pr-4' : ''
                      }`}
                    >
                      {key != 'null' && (
                        <h3 className="flex content-center font-semibold text-black uppercase text-12 mob-text-xs">
                          <span className="font-medium opacity_056 text-primary">
                            <span className="hidden sm:inline">
                              {key.toLowerCase()}
                            </span>
                            <span className="inline mr-1 sm:hidden">
                              Colour:{' '}
                            </span>
                          </span>
                          {/* <span className='mr-1'>:</span> */}
                          {currentVariantData && (
                            <>
                              {!forInputSelection ? (
                                <>
                                  {!selectedGroupName ? (
                                    values?.find((x: any) =>
                                      matchStrings(
                                        x?.fieldValue,
                                        currentVariantData,
                                        true
                                      )
                                    )?.fieldLabel
                                  ) : selectedGroupName &&
                                    selectedGroupName[key] ? (
                                    <span className="font-semibold">
                                      {' '}
                                      {selectedGroupName[key]}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </>
                              ) : (
                                <>
                                  {
                                    values?.find((x: any) =>
                                      matchStrings(
                                        x?.fieldValue,
                                        selectedValue
                                          ? selectedValue[fieldCode]
                                          : '',
                                        true
                                      )
                                    )?.fieldLabel
                                  }
                                </>
                              )}
                            </>
                          )}
                        </h3>
                      )}
                    </div>
                    <div className="col-span-1 mt-2 sm:mt-0">
                      <div role="list" className="flex flex-wrap color-panel">
                        <Swiper
                          slidesPerView={6.5}
                          spaceBetween={5}
                          navigation={true}
                          slidesPerGroup={5}
                          loop={false}
                          freeMode={true}
                          modules={[FreeMode]}
                          breakpoints={{
                            520: {
                              slidesPerView: 7.5,
                            },
                            640: {
                              slidesPerView: 7.5,
                            },
                            768: {
                              slidesPerView: 8.5,
                            },
                            1024: {
                              slidesPerView: 5.5,
                            },
                          }}
                        >
                          <div
                            role="list"
                            className="inline-flex mx-4 space-x-0 sm:mx-0 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-4 lg:gap-x-0"
                          >
                            {values
                              ?.sort(
                                (
                                  a: { displayOrder: number },
                                  b: { displayOrder: number }
                                ) => a.displayOrder - b.displayOrder
                              )
                              ?.map((item: any, idx: any) => (
                                <SwiperSlide
                                  className={`px-0 ${
                                    idx === 0 ? 'cs-mr-1' : ''
                                  }`}
                                  key={`product-${idx}-slider`}
                                >
                                  <div
                                    className={`-m-0.5 relative p-0.5 pdp-color-variant w-16 rounded flex items-center justify-center cursor-pointer`}
                                  >
                                    <span className="sr-only">
                                      {item.fieldName} {item.value}
                                    </span>
                                    <Link
                                      legacyBehavior
                                      href={`/${item?.slug}`}
                                    >
                                      <a
                                        className={classNames(item.fieldvalue)}
                                        href="javascript: void(0)"
                                        onClick={(ev: any) => {
                                          ev.preventDefault()
                                          ev.stopPropagation()
                                          handleChange(
                                            key,
                                            item.fieldValue,
                                            item,
                                            idx,
                                            values
                                          )
                                          setScrollY(currentScrollY)
                                        }}
                                      >
                                        <img
                                          src={
                                            generateUri(
                                              item?.fieldValue,
                                              'h=128&w=200&fm=webp'
                                            ) || IMG_PLACEHOLDER
                                          }
                                          alt={
                                            item?.fieldValue || item?.fieldValue
                                          }
                                          height={128}
                                          width={200}
                                          className={`${
                                            matchStrings(slug, item?.slug, true)
                                              ? 'border-highlight'
                                              : 'border-gray-200'
                                          } rounded border  hover:border-gray-400 swatch-img`}
                                          style={css}
                                          onError={(e: any) => handleError(e)}
                                        />
                                      </a>
                                    </Link>
                                  </div>
                                </SwiperSlide>
                              ))}
                          </div>
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      {/* ) : ( */}
      <div className="desktop-laptop">
        <div
          className="block w-full border-t border-gray-200"
          id="productColors"
        >
          {_getAllGroups?.map(([key, values]: any, iid: number) => {
            return (
              <div
                className="px-4 pb-4 my-4 border-b border-gray-200 border-dashed border-none-pdp sm:px-0"
                key={`product-${iid}-current-data`}
              >
                <span className="sr-only">{key}</span>
                <div className="grid content-center grid-cols-1">
                  <div className="flex content-center col-span-1">
                    <h3 className="flex content-center font-semibold text-black capitalize text-16">
                      {key == 'null' ? (
                        <span className="text-primary font-clr-quick font-color-weight-300">
                          Colour
                        </span>
                      ) : (
                        <span
                          className={`${
                            key.toLowerCase() === CLEARANCE_TEXT_VARIABLE
                              ? 'text-orange'
                              : 'text-primary'
                          } font-clr-quick font-color-weight-300`}
                        >
                          {key.toLowerCase()}
                        </span>
                      )}

                      <span className="mr-1">:</span>
                      {currentVariantData && (
                        <>
                          {!selectedGroupName ? (
                            values?.find((x: any) =>
                              matchStrings(
                                x?.fieldValue,
                                currentVariantData,
                                true
                              )
                            )?.fieldLabel
                          ) : selectedGroupName && selectedGroupName[key] ? (
                            <span className="font-semibold">
                              {' '}
                              {selectedGroupName[key]}
                            </span>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </h3>
                  </div>
                  <div className="col-span-1 mt-2">
                    <div role="list" className="flex flex-wrap color-panel">
                      {values
                        ?.sort(
                          (
                            a: { displayOrder: number },
                            b: { displayOrder: number }
                          ) => a.displayOrder - b.displayOrder
                        )
                        ?.map((item: any, idx: any) => {
                          return (
                            <div
                              key={`product-${idx}-new-data`}
                              className={`-m-0.5 relative p-0.5 pdp-color-variant w-16 rounded flex items-center justify-center cursor-pointer`}
                            >
                              <span className="sr-only">
                                {item.fieldName} {item.value}
                              </span>
                              <Link
                                legacyBehavior
                                href={`/${removePrecedingSlash(item?.slug)}`}
                              >
                                <a
                                  className={classNames(item.fieldvalue)}
                                  href="javascript: void(0)"
                                  onClick={(ev: any) => {
                                    ev.preventDefault()
                                    ev.stopPropagation()
                                    handleChange(
                                      key,
                                      item.fieldValue,
                                      item,
                                      idx,
                                      values
                                    )
                                    setScrollY(currentScrollY)
                                  }}
                                >
                                  {!forInputSelection ? (
                                    <img
                                      src={
                                        generateUri(
                                          item?.fieldValue,
                                          'h=136&w=210&fm=webp'
                                        ) || IMG_PLACEHOLDER
                                      }
                                      alt={item?.fieldValue || item?.fieldValue}
                                      className={`${
                                        matchStrings(slug, item?.slug, true)
                                          ? 'border-highlight'
                                          : 'border-gray-200'
                                      } rounded border  hover:border-gray-400 swatch-img`}
                                      style={css}
                                      width={200}
                                      height={138}
                                      onError={(e: any) => handleError(e)}
                                    />
                                  ) : (
                                    <img
                                      src={
                                        generateUri(
                                          item?.fieldValue,
                                          'h=60&w=100&fm=webp'
                                        ) || IMG_PLACEHOLDER
                                      }
                                      alt={item?.fieldValue || item?.fieldValue}
                                      className={`${
                                        matchStrings(slug, item?.slug, true)
                                          ? 'border-highlight'
                                          : 'border-gray-200'
                                      } rounded border  hover:border-gray-400 swatch-img`}
                                      style={css}
                                      width={100}
                                      height={60}
                                      onError={(e: any) => handleError(e)}
                                    />
                                  )}
                                </a>
                              </Link>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      {/* )} */}
    </>
  )
}
